import { ACCOUNT_TYPES, BANKS } from "../../utils/bankConstants";

const mask = (value) => (value ? `•••• ${String(value).slice(-4)}` : "-");

const Row = ({ label, children }) => (
  <div className="ui-kv__row">
    <span className="ui-kv__label">{label}</span>
    <span className="ui-kv__value">{children}</span>
  </div>
);

export const CardUserBankAccount = ({ user }) => {
  const bank = user.bankAccount;

  return (
    <div className="ui-card">
      <div style={{ display: "flex", alignItems: "center", gap: 9, marginBottom: 16 }}>
        <i className="ri-bank-line" style={{ color: "#4B36F0", fontSize: 17 }} />
        <h3 style={{ margin: 0, fontSize: 15, fontWeight: 700 }}>Cuenta bancaria</h3>
      </div>

      {!bank ? (
        <p style={{ margin: 0, color: "#8A91AE", fontSize: 12.5 }}>No hay información registrada.</p>
      ) : (
        <div className="ui-kv">
          <Row label="Banco">{BANKS.find((b) => b.id === bank.bankCode)?.name || "-"}</Row>
          <Row label="Tipo">{ACCOUNT_TYPES.find((t) => t.id === bank.accountType)?.label || "-"}</Row>
          <Row label={bank.accountType === 4 ? "Número de celular" : "Número"}>
            <span className="ui-kv__value--mono">{mask(bank.accountNumber)}</span>
          </Row>
          <Row label="Titular">{bank.accountHolderName || "-"}</Row>
          <Row label="Documento">
            <span className="ui-kv__value--mono">
              {bank.identificationType} {bank.identificationNumber}
            </span>
          </Row>
          <Row label="Aceptó términos">{bank.acceptedTerms ? "Sí" : "No"}</Row>
        </div>
      )}
    </div>
  );
};
